import React from 'react';
import DynamicTeamList from '../components/DynamicTeamList';

const TeamsPage = () => {
  return (
    <div>
      <DynamicTeamList title="Teams" />
    </div>
  );
};

export default TeamsPage;
